module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00067"
    }
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("This book is a record of a pleasure trip. If it were a record of a solemn scientific expedition, it would have about it that gravity, that profundity, and that impressive incomprehensibility which are so proper to works of that kind, and withal so attractive. Yet notwithstanding it is only a record of a pic-nic, it has a purpose, which is to suggest to the reader how he would be likely to see Europe and the East if he looked at them with his own eyes instead of the eyes of those who traveled in those countries before him. I make small pretense of showing anyone how he ought to look at objects of interest beyond the sea—other books do that, and therefore, even if I were competent to do it, there is no need.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("I offer no apologies for any departures from the usual style of travel-writing that may be charged against me—for I think I have seen with impartial eyes, and I am sure I have written at least honestly, whether wisely or not.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("In this volume I have used portions of letters which I wrote for the Daily Alta California, of San Francisco, the proprietors of that journal having waived their rights and given me the necessary permission. I have also inserted portions of several letters written for the New York Tribune and the New York Herald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("THE AUTHOR. SAN FRANCISCO.\n")]), _vm._v(" "), _c('div', {
    staticClass: "calibre6",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e195d94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0